export default __webpack_public_path__ + "static/img3@2x-b6cf60b51b3b1f47c7670de5b1d46685.jpg";